import React from "react";

import {
  DataType,
  GraphConfig,
} from "@intelligems/ig-types/schemas/analytics/custom-graphs";
import { useTheme } from "@mui/material";
import { BarMetricData } from "@src/types/analytics";

export const BarLabel = (
  props: any,
  config: GraphConfig,
  graphValueFormatter: ({
    isAxisTick,
    value,
    configDataTypes,
    _index,
    decimalAmountShown,
  }: {
    isAxisTick: boolean;
    value: number;
    configDataTypes: DataType[];
    _index?: number;
    decimalAmountShown?: number;
  }) => string | undefined,
  groupMetricData: BarMetricData[],
  compareGroupA?: string,
  compareGroupB?: string,
  index?: number,
  isNewGraph?: boolean,
  decimalAmountShown?: number
): any => {
  const theme = useTheme();
  const { x, y, width, value, height } = props.props;

  return (
    <text
      x={x + width / 2}
      y={y}
      dy={height < 30 ? -10 : value > -1 ? 22 : -30}
      style={{
        fill: height <= 30 ? theme.palette.text.secondary : "white",
        fontFamily: theme.typography.fontFamily,
        fontSize: 12,
      }}
      textAnchor="middle"
      dominantBaseline="middle"
    >
      {props.formattedValue ??
        props.graphValueFormatter({
          isAxisTick: false,
          value,
          configDataTypes: props.config.dataTypes,
          _index: props.index,
          decimalAmountShown: props.decimalAmountShown,
        })}
    </text>
  );
};
